module.exports = __webpack_public_path__ + "img/gog-galaxy.d0e889a9.png";